<div class="h-100 d-flex flex-column gap-8">
  <div class="w-100 h-100 d-flex flex-column gap-3">
    <div class="w-100 d-flex gap-6 align-items-center">
      <div class="d-flex align-items-center w-50">
        <si-form-item label="Name" class="flex-grow-1">
          <input
            #name="ngModel"
            type="text"
            class="form-control"
            name="newTrackName"
            placeholder="München - Berlin"
            required
            [(ngModel)]="newItemName"
          />
        </si-form-item>
        @if (this.dataType() !== 'vehicle') {
          <button
            type="button"
            class="btn btn-circle btn-tertiary element-ai"
            aria-label="generate name"
            (click)="generateName()"
          ></button>
        }
      </div>

      <si-form-item label="Version" class="w-50">
        <input
          #version="ngModel"
          type="text"
          class="form-control"
          name="newTrackVersion"
          placeholder="1.0, Without curves, etc."
          required
          [(ngModel)]="newItemVersion"
        />
      </si-form-item>
    </div>
    <div class="w-100">
      <si-form-item [label]="'SHARED.DESCRIPTION' | translate">
        <input
          #version="ngModel"
          type="text"
          class="form-control"
          name="newTrackDescription"
          placeholder="Without stations Hbf and S-Bahnhof"
          [(ngModel)]="newItemDescription"
        />
      </si-form-item>
    </div>
    @if (mode() === 'save') {
      <div class="w-100 d-flex gap-3 align-items-end">
        <si-form-item label="Workspace" class="w-75">
          <select
            #workspace="ngModel"
            aria-label="number"
            class="form-select"
            required
            [(ngModel)]="newItemWorkspace"
          >
            @for (workspace of availableWorkspaces(); track $index) {
              <option [ngValue]="workspace">
                {{ workspace.name }}
              </option>
            }
          </select>
        </si-form-item>
        <si-form-item class="w-25" label="">
          <button
            type="button"
            class="btn btn-primary w-100"
            [disabled]="version.invalid || name.invalid || workspace.invalid"
            (click)="saveNewItem()"
          >
            {{ 'SHARED.SAVE' | translate }}
          </button>
        </si-form-item>
      </div>
      @if (sourceWorkspaceHint(); as hint) {
        <div class="alert alert-info mt-4" role="status">
          {{
            'SAVE_MODAL.SOURCE_WORKSPACE_INFO'
              | translate: { workspace: hint.source, target: hint.target }
          }}
        </div>
      }
    } @else {
      <div class="w-100 d-flex justify-content-end">
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="version.invalid || name.invalid"
          (click)="saveNewItem()"
        >
          {{ 'SHARED.RENAME' | translate }}
        </button>
      </div>
    }
  </div>
</div>
